import React from 'react';
import {
  SvgContainer,
  VariantSvgContainerProps
} from '@/components/icon/SvgContainer';

export const MinusCircleIcon = ({
  filled,
  ...props
}: VariantSvgContainerProps) => (
  <SvgContainer {...props}>
    {filled ? (
      <path
        fillRule="evenodd"
        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z"
        clipRule="evenodd"
      />
    ) : (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    )}
  </SvgContainer>
);
